"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HardwareInfoT = exports.HardwareInfo = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
const ipv4_address_js_1 = require("../../../solarxr-protocol/datatypes/ipv4-address.js");
const board_type_js_1 = require("../../../solarxr-protocol/datatypes/hardware-info/board-type.js");
const hardware_address_js_1 = require("../../../solarxr-protocol/datatypes/hardware-info/hardware-address.js");
const mcu_type_js_1 = require("../../../solarxr-protocol/datatypes/hardware-info/mcu-type.js");
/**
 * Mostly static info about the device's hardware/firmware.
 */
class HardwareInfo {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsHardwareInfo(bb, obj) {
        return (obj || new HardwareInfo()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsHardwareInfo(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new HardwareInfo()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    mcuId() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.readUint16(this.bb_pos + offset) : mcu_type_js_1.McuType.Other;
    }
    displayName(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    model(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    manufacturer(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 10);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    hardwareRevision(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 12);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    firmwareVersion(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 14);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    hardwareAddress(obj) {
        const offset = this.bb.__offset(this.bb_pos, 16);
        return offset ? (obj || new hardware_address_js_1.HardwareAddress()).__init(this.bb_pos + offset, this.bb) : null;
    }
    ipAddress(obj) {
        const offset = this.bb.__offset(this.bb_pos, 18);
        return offset ? (obj || new ipv4_address_js_1.Ipv4Address()).__init(this.bb_pos + offset, this.bb) : null;
    }
    boardType(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 20);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    /**
     * An enum listing all the board types supported by the firmware
     */
    officialBoardType() {
        const offset = this.bb.__offset(this.bb_pos, 22);
        return offset ? this.bb.readUint16(this.bb_pos + offset) : board_type_js_1.BoardType.UNKNOWN;
    }
    hardwareIdentifier(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 24);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    /**
     * The version of the protocol it's using to communicate with server
     */
    networkProtocolVersion() {
        const offset = this.bb.__offset(this.bb_pos, 26);
        return offset ? this.bb.readUint16(this.bb_pos + offset) : null;
    }
    static startHardwareInfo(builder) {
        builder.startObject(12);
    }
    static addMcuId(builder, mcuId) {
        builder.addFieldInt16(0, mcuId, mcu_type_js_1.McuType.Other);
    }
    static addDisplayName(builder, displayNameOffset) {
        builder.addFieldOffset(1, displayNameOffset, 0);
    }
    static addModel(builder, modelOffset) {
        builder.addFieldOffset(2, modelOffset, 0);
    }
    static addManufacturer(builder, manufacturerOffset) {
        builder.addFieldOffset(3, manufacturerOffset, 0);
    }
    static addHardwareRevision(builder, hardwareRevisionOffset) {
        builder.addFieldOffset(4, hardwareRevisionOffset, 0);
    }
    static addFirmwareVersion(builder, firmwareVersionOffset) {
        builder.addFieldOffset(5, firmwareVersionOffset, 0);
    }
    static addHardwareAddress(builder, hardwareAddressOffset) {
        builder.addFieldStruct(6, hardwareAddressOffset, 0);
    }
    static addIpAddress(builder, ipAddressOffset) {
        builder.addFieldStruct(7, ipAddressOffset, 0);
    }
    static addBoardType(builder, boardTypeOffset) {
        builder.addFieldOffset(8, boardTypeOffset, 0);
    }
    static addOfficialBoardType(builder, officialBoardType) {
        builder.addFieldInt16(9, officialBoardType, board_type_js_1.BoardType.UNKNOWN);
    }
    static addHardwareIdentifier(builder, hardwareIdentifierOffset) {
        builder.addFieldOffset(10, hardwareIdentifierOffset, 0);
    }
    static addNetworkProtocolVersion(builder, networkProtocolVersion) {
        builder.addFieldInt16(11, networkProtocolVersion, 0);
    }
    static endHardwareInfo(builder) {
        const offset = builder.endObject();
        return offset;
    }
    unpack() {
        return new HardwareInfoT(this.mcuId(), this.displayName(), this.model(), this.manufacturer(), this.hardwareRevision(), this.firmwareVersion(), (this.hardwareAddress() !== null ? this.hardwareAddress().unpack() : null), (this.ipAddress() !== null ? this.ipAddress().unpack() : null), this.boardType(), this.officialBoardType(), this.hardwareIdentifier(), this.networkProtocolVersion());
    }
    unpackTo(_o) {
        _o.mcuId = this.mcuId();
        _o.displayName = this.displayName();
        _o.model = this.model();
        _o.manufacturer = this.manufacturer();
        _o.hardwareRevision = this.hardwareRevision();
        _o.firmwareVersion = this.firmwareVersion();
        _o.hardwareAddress = (this.hardwareAddress() !== null ? this.hardwareAddress().unpack() : null);
        _o.ipAddress = (this.ipAddress() !== null ? this.ipAddress().unpack() : null);
        _o.boardType = this.boardType();
        _o.officialBoardType = this.officialBoardType();
        _o.hardwareIdentifier = this.hardwareIdentifier();
        _o.networkProtocolVersion = this.networkProtocolVersion();
    }
}
exports.HardwareInfo = HardwareInfo;
class HardwareInfoT {
    constructor(mcuId = mcu_type_js_1.McuType.Other, displayName = null, model = null, manufacturer = null, hardwareRevision = null, firmwareVersion = null, hardwareAddress = null, ipAddress = null, boardType = null, officialBoardType = board_type_js_1.BoardType.UNKNOWN, hardwareIdentifier = null, networkProtocolVersion = null) {
        this.mcuId = mcuId;
        this.displayName = displayName;
        this.model = model;
        this.manufacturer = manufacturer;
        this.hardwareRevision = hardwareRevision;
        this.firmwareVersion = firmwareVersion;
        this.hardwareAddress = hardwareAddress;
        this.ipAddress = ipAddress;
        this.boardType = boardType;
        this.officialBoardType = officialBoardType;
        this.hardwareIdentifier = hardwareIdentifier;
        this.networkProtocolVersion = networkProtocolVersion;
    }
    pack(builder) {
        const displayName = (this.displayName !== null ? builder.createString(this.displayName) : 0);
        const model = (this.model !== null ? builder.createString(this.model) : 0);
        const manufacturer = (this.manufacturer !== null ? builder.createString(this.manufacturer) : 0);
        const hardwareRevision = (this.hardwareRevision !== null ? builder.createString(this.hardwareRevision) : 0);
        const firmwareVersion = (this.firmwareVersion !== null ? builder.createString(this.firmwareVersion) : 0);
        const boardType = (this.boardType !== null ? builder.createString(this.boardType) : 0);
        const hardwareIdentifier = (this.hardwareIdentifier !== null ? builder.createString(this.hardwareIdentifier) : 0);
        HardwareInfo.startHardwareInfo(builder);
        HardwareInfo.addMcuId(builder, this.mcuId);
        HardwareInfo.addDisplayName(builder, displayName);
        HardwareInfo.addModel(builder, model);
        HardwareInfo.addManufacturer(builder, manufacturer);
        HardwareInfo.addHardwareRevision(builder, hardwareRevision);
        HardwareInfo.addFirmwareVersion(builder, firmwareVersion);
        HardwareInfo.addHardwareAddress(builder, (this.hardwareAddress !== null ? this.hardwareAddress.pack(builder) : 0));
        HardwareInfo.addIpAddress(builder, (this.ipAddress !== null ? this.ipAddress.pack(builder) : 0));
        HardwareInfo.addBoardType(builder, boardType);
        HardwareInfo.addOfficialBoardType(builder, this.officialBoardType);
        HardwareInfo.addHardwareIdentifier(builder, hardwareIdentifier);
        if (this.networkProtocolVersion !== null)
            HardwareInfo.addNetworkProtocolVersion(builder, this.networkProtocolVersion);
        return HardwareInfo.endHardwareInfo(builder);
    }
}
exports.HardwareInfoT = HardwareInfoT;
